import React from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import { useEventSchedule } from '../../../../../../data/hooks/schedule/useEventSchedule';
import {isSpeeddate} from '../../../../../../data/filters/schedule/isSpeeddate';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import moment from 'moment';
import {identity} from 'lodash';
import {DATE_FORMAT_URL} from '../../../../../../data/constants/datetime';

function StepSpeeddate(props) {
    const {eventId} = props,
        i18n = useI18n(),
        speeddates = useEventSchedule(eventId, {filter: isSpeeddate}),
        futureSpeeddates = speeddates.filter(session => moment().isSameOrBefore(session.start_local, 'day')),
        speedate = [...futureSpeeddates, ...speeddates].filter(identity)[0],
        visible = !!speedate,
        date = moment(speedate?.start_local).format(DATE_FORMAT_URL);

    return (
        <StartNetworkingStep href={['/events', eventId, 'schedule', date].join('/')} visible={visible}>
            {i18n['start.speeddate']}
        </StartNetworkingStep>
    );
}

export default StepSpeeddate;
